interface TableCellProps {
  children: React.ReactNode;
  className?: string;
  /** If set, truncates string children after this number of characters */
  truncateAfter?: number;
  onClick?: (e: React.MouseEvent) => void;
}

export const TableCell = ({ children, className, truncateAfter, onClick }: TableCellProps) => {
  let content = children;

  if (
    typeof truncateAfter === 'number' &&
    truncateAfter > 0 &&
    typeof children === 'string' &&
    children.length > truncateAfter
  ) {
    content = children.slice(0, truncateAfter) + '…';
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      // Create a synthetic mouse event for keyboard interactions
      const syntheticMouseEvent = {
        ...e,
        type: 'click',
        button: 0,
        buttons: 1,
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0,
        pageX: 0,
        pageY: 0,
        movementX: 0,
        movementY: 0,
        relatedTarget: null,
        which: 1,
        detail: 1,
        view: e.currentTarget.ownerDocument?.defaultView || null,
      } as unknown as React.MouseEvent;
      onClick(syntheticMouseEvent);
    }
  };

  return (
    <span
      className={className}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {content}
    </span>
  );
};
